// Wait for the DOM to be fully loaded before running the script
document.addEventListener("DOMContentLoaded", () => {
	const checkboxes = document.querySelectorAll(
		'.wpcf7-form input[type="checkbox"]'
	);

	// Loop through each checkbox once
	checkboxes.forEach((checkbox) => {
		// Create the custom checkbox element that the SCSS is looking for
		const customCheckbox = document.createElement("span");
		customCheckbox.className = "custom-checkbox";

		// Insert the custom span right after the actual checkbox input.
		// The CSS can now style it and react to the :checked state.
		checkbox.after(customCheckbox);

		// This listener is for debugging and will log the state to the console.
		checkbox.addEventListener("change", () => {
			console.log(
				`Checkbox is ${
					checkbox.checked ? "checked" : "unchecked"
				}. Value: ${checkbox.value}`
			);
		});
	});
});
